module.exports = __webpack_public_path__ + "components/flag/static/square/cr-ea7049f6e2adedcad8bcb502ca3bc079.svg";